<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<v-container
		fluid
		grid-list-md
	>
		<v-data-iterator
			:items="backgroundData"
			:items-per-page="4"
		>
			<template #default="props">
				<v-row>
					<v-col
						v-for="item in props.items"
						:key="item.name"
						cols="12"
						sm="6"
						md="4"
						lg="3"
					>
						<v-card>
							<v-card-title>
								{{ item.name }}
							</v-card-title>
							<v-divider />
							<v-list density="compact">
								<v-list-item>
									<span><translate>Risk</translate>:</span>
									<div class="align-end">
										{{ item.risk }}
									</div>
								</v-list-item>
								<v-list-item>
									<span><translate>Metric Value</translate>:</span>
									<div class="align-end">
										{{ item.metricValue }}
									</div>
								</v-list-item>
								<v-list-item>
									<span><translate>Precision</translate>:</span>
									<div class="align-end">
										{{ item.precision }}
									</div>
								</v-list-item>
								<v-list-item>
									<span><translate>Description</translate>:</span>
									<div class="align-end">
										{{ item.description }}
									</div>
								</v-list-item>
							</v-list>
						</v-card>
					</v-col>
				</v-row>
			</template>
		</v-data-iterator>
	</v-container>
</template>

<script>

export default {
	props: {
		backgroundData: {
			type: Array,
			required: true,
		},
	},
	data () {
		return {
			suspiciousData: [],
			rowsPerPage: [12, 24, -1, ],
		};
	},
};
</script>

<style scoped>
.card-title {
	word-break: break-word
}

</style>
